import EventReporterService from "./EventReporterService";
import { ApplePayEventListenerEnumsObj } from "../../enums/ApplePayEventListenerEnum";
import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk";
import { getAdditionalInfo } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
/** @internal */
export var PAYAIR_APPLE_PAY_EVENT_REPORTER_LISTENER = "PAYAIR_APPLE_PAY_EVENT_REPORTER_LISTENER";
/** @internal */
var EventReporter = /** @class */ (function () {
    function EventReporter() {
        var _this = this;
        this.initEventReporterService = function (pspName, transactionId, merchantId) {
            _this.transactionId = transactionId;
            _this.merchantId = merchantId;
            _this.eventReporterService = new EventReporterService(pspName);
        };
    }
    EventReporter.prototype.handleEvent = function (eventParams) {
        var applePayEvent = {
            additionalInfo: getAdditionalInfo(eventParams.additionalInfo),
            clientTimestamp: Date.now(),
            eventType: eventParams.eventType,
            merchantId: this.merchantId ? this.merchantId : "",
            requestId: eventParams.requestId,
            sessionId: eventParams.sessionId,
            transactionId: this.transactionId ? this.transactionId : "",
            sdk: BaseEcomSdkEnumsObj.PAYAIR_APPLE_PAY_SDK,
        };
        if (this.eventReporterService) {
            this.eventReporterService.reportEvent(applePayEvent);
        }
        window.dispatchEvent(new CustomEvent(ApplePayEventListenerEnumsObj.PAYAIR_APPLE_PAY_SDK_LISTENER, { detail: applePayEvent }));
    };
    return EventReporter;
}());
export default EventReporter;
